module.exports = __webpack_public_path__ + "static/img/startripgroup.a61e477.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/startripgroup.png
// module id = b+zh
// module chunks = 1